import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import BackspaceOutlinedIcon from "@mui/icons-material/BackspaceOutlined";
import SyncIcon from "@mui/icons-material/Sync";
import axios from "axios";
import configs, { getParameterByName } from "../Constants";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { Navigate } from "react-router-dom";
import Button from "@mui/material/Button";
import Avatar from "@mui/material/Avatar";
import { Alert, AlertTitle } from "@mui/material";
const RolesLogin = (props) => {
  const [pin, setPin] = useState("");
  const [rolesData, setRolesData] = useState([]);
  const [merchantData, setMerchantData] = useState([]);
  const [roleId, setRoleId] = useState("");
  const [vertical] = useState("top");
  const [horizontal] = useState("center");
  const [open, setOpen] = useState(false);
  const [userSets, setUserSets] = useState(null);

  const [errorMessage, setErrorMessage] = useState("");

  //console.log(props);
  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get(
        configs.baseURL +
        "/api/settings/merchants/" +
        getParameterByName("merchantCode") +
        "/open"
      )
      .then((res) => {
        console.log(res.data);
        setMerchantData(res.data);
        localStorage.setItem("merchantData", JSON.stringify(res.data));
      });
  }, []);
  //console.log(merchantData);





  const handleClose = () => {
    setOpen(false);
    setErrorMessage(false);
  };
  let wrongPinCout = 0;

  let baseURL = configs.baseURL;
  
  const fetchMembers = () => {
    axios
      .get(
        baseURL +
        "/api/settings/merchants/" +
        getParameterByName("merchantCode") +
        "/members/open"
      )
      .then((res) => {
        console.log(res.data);
        setRolesData(res.data);
      });
  };

  useEffect(() => {
    if (!rolesData.length) {
      fetchMembers();
    }
  }, []);

  function appendToInput(value) {
    console.log(value);
    setPin((p) => p + value);
  }

  function handleBackSpace() {
    setPin(pin.slice(0, -1));
  }

  const handlePass = () => {
    window.location.href = window.origin;
  };

  function handleSubmit() {
    let isLoggedIn = false;
    localStorage.setItem("isMerchant", true);
    localStorage.setItem("isMember", true);
    if (wrongPinCout <= 5) {
      if (roleId && pin) {
        axios({
          method: "post",
          url: configs.authapi + "/user/validate-member-names-pin",
          data: {
            _id: roleId,
            mpin: pin,
          },
        })
          .then((res) => {
            setPin("");
            wrongPinCout = 0;
            isLoggedIn = true;
            console.log()
            localStorage.setItem("token", res.data.user.token);
            localStorage.setItem("userData", JSON.stringify(res.data.user));
            // if (!localStorage.getItem("userData")) {
            //   window.location.reload();
            // }
            axios
              .get(
                configs.baseURL + "/api/settings/" + res.data.user.parentUser,
                {
                  headers: {
                    Authorization: `Bearer ${res.data.user.token}`,
                  },
                }
              )
              .then((resset) => {
                console.log(resset);
                if (resset.data.length) {
                  localStorage.setItem(
                    "merchantData",
                    JSON.stringify(resset.data[0])
                  );

                  //setUserSets(merchantDtl);
                  let merchantDtl = localStorage.getItem("merchantData");
                  merchantDtl = JSON.parse(merchantDtl);
                  if (merchantDtl.activeProviderId) {
                    axios
                      .get(
                        baseURL +
                        "/api/thp-source/" +
                        merchantDtl.activeProviderId
                      )
                      .then((res) => {
                        //setThirdParty(res.data);
                      });
                  }
                  if (document.getElementById("navBar")) {
                    document.getElementById("navBar").style.display = "flex";
                  }
                  
                  // Reload the page fully to initialize UserPermissionsContext and other global states
                  window.location.href = window.location.origin + "/orderList?merchantCode=" + getParameterByName("merchantCode");

                }
              });
          })
          .catch((err) => {
            console.log(err);
            setErrorMessage(err.message);
            setPin("");
            wrongPinCout = wrongPinCout + 1;
          });
        //    history("/epos")
      } else {
        setOpen(true);
      }
      //isLoggedIn&& navigate("/epos");
    } else {
      console.log("Come again");
    }
  }

  function stringAvatar(name) {
    return {
      sx: {
        bgcolor: stringToColor(name),
      },
      children: `${name.split(" ")[0][0]}`,
    };
  }

  function stringToColor(string) {
    let hash = 0;
    let i;

    for (i = 0; i < string.length; i += 1) {
      hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }

    let color = "#";

    for (i = 0; i < 3; i += 1) {
      const value = (hash >> (i * 8)) & 0xff;
      color += `00${value.toString(16)}`.slice(-2);
    }
    return color;
  }
  const handleKeyDown = (e) => {
    const { key } = e;
    if (/\d/.test(key)) {
      appendToInput(key);
    } else if (key === "Backspace") {
      handleBackSpace();
    } else if (key === "Enter") {
      handleSubmit();
    }
  };
  if (document.getElementById("navBar")) {
    document.getElementById("navBar").style.display = "none";
  }
  // Add event listener for keyboard events
  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [pin]);
  // if (redirectToOrders) {
  //     return <Navigate to="/orders" />;
  // }

  return (
    <>
      <div className="container" id="role_container" style={{ backgroundColor: merchantData.themeColor }}>
        <div className="sub_container">
          <div>
            <span
              className="logo"
              style={{
                backgroundImage: `url(${merchantData ? merchantData.logoImg : ""
                  })`,
                width: "200px",
                height: "auto",
                minWidth: "200px",
                minHeight: "200px"
              }}
            ></span>


            <button className="logoin_btn" onClick={handlePass}>
              LOG-IN WITH PASSWORD
            </button>

          </div>

          <div className="input_container">
            {roleId && (
              <h2 style={{ color: merchantData.themeTxtColor, marginBottom: "20px" }}>
                {"Welcome " +
                  rolesData.filter((r) => r.id == roleId)[0].firstName +
                  "!"}
              </h2>
            )}
            {!roleId && <div className="roles_cont">
              <h3 style={{ color: merchantData.themeTxtColor, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                Select Staff Name
                <SyncIcon 
                  sx={{ cursor: "pointer", marginLeft: "10px" }} 
                  onClick={fetchMembers}
                  titleAccess="Refresh Members"
                />
              </h3>


              {!roleId && rolesData.length > 0 ?
                rolesData.map((role) => (
                  <Button
                    key={role.id}
                    onClick={() => setRoleId(role.id)}
                    value={role.id}
                    variant="outlined"
                    style={{ width: "150px", height: "130px" }}
                  >
                    <span
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        fontSize: "1.2em",
                        fontWeight: "bold"
                      }}
                    >
                      <Avatar {...stringAvatar(role.firstName)} style={{ width: '50px', height: "50px" }} />
                      {role.firstName}
                    </span>
                  </Button>
                )) : ""}


            </div>}

            <div style={roleId ? { display: "block" } : { display: "none" }}>
              <div className="screen">
                <div className="screen_feild">
                  <input readOnly type="text" value={"*".repeat(pin.length)} style={{ width: "200px", textAlign: "center", color: merchantData.themeTxtColor, fontSize: "30px!important" }} />
                  <BackspaceOutlinedIcon style={{ color: merchantData.themeTxtColor }} onClick={handleBackSpace} />
                </div>
              </div>
              <div className="keyboard_container">
                <h3 className="input_title" style={{ color: merchantData.themeTxtColor }}>SELECT MPIN</h3>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 80px)', gap: '15px 40px', justifyContent: 'center', margin: '20px auto' }}>
                  {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((num) => (
                    <Button
                      key={num}
                      variant="outlined"
                      onClick={() => appendToInput(num.toString())}
                      style={{
                        width: "80px",
                        minWidth: "80px",
                        height: "80px",
                        padding: 0,
                        borderRadius: "50%",
                        fontSize: "30px",
                        fontWeight: "300",
                        color: merchantData.themeTxtColor || "#333",
                        borderColor: merchantData.themeTxtColor || "#bbb",
                        boxShadow: "0 4px 10px rgba(0,0,0,0.08)",
                      }}
                    >
                      {num}
                    </Button>
                  ))}
                  <Button
                    variant="outlined"
                    onClick={() => appendToInput("0")}
                    style={{
                      width: "80px",
                      minWidth: "80px",
                      height: "80px",
                      padding: 0,
                      borderRadius: "50%",
                      fontSize: "30px",
                      fontWeight: "300",
                      color: merchantData.themeTxtColor || "#333",
                      borderColor: merchantData.themeTxtColor || "#bbb",
                      boxShadow: "0 4px 10px rgba(0,0,0,0.08)",
                    }}
                  >
                    0
                  </Button>
                  <Button
                    variant="contained"
                    onClick={handleSubmit}
                    style={{
                      gridColumn: "span 2",
                      width: "100%",
                      height: "80px",
                      padding: 0,
                      borderRadius: "40px",
                      fontSize: "20px",
                      fontWeight: "bold",
                      letterSpacing: "1px",
                      backgroundColor: merchantData.themeTxtColor || "#000",
                      color: merchantData.themeColor,
                      boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
                    }}
                  >
                    NEXT
                  </Button>
                </div>
              </div>
            </div>
          </div>

          <Snackbar
            anchorOrigin={{ vertical, horizontal }}
            open={errorMessage}
            onClose={handleClose}
            key={vertical + horizontal}
          >
            <MuiAlert onClose={handleClose} severity="error">
              Error: Wrong PIN entered!!, Please Correct
            </MuiAlert>
          </Snackbar>
        </div>
      </div>
    </>
  );
};

export default RolesLogin;
